import React from 'react'
import { useTranslation } from 'react-i18next'

import Separator from '@/components-latest/primitives/Separator'
import type { BuyXGetYCampaign } from '@/ducks/campaigns/campaigns.types'

import CampaignDetailsItemRow from './CampaignDetailsItemRow'
import Styles from './CampaignDetailsModal.module.scss'

type Props = {
  campaign: BuyXGetYCampaign
}

const BuyXGetYDetails = ({ campaign }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <Separator />
      <div className={Styles.section}>
        <h3 className={Styles.sectionTitle}>
          {t('marketing.campaigns.details.discount-details')}
        </h3>
        <div className={Styles.section}>
          <h4 className={Styles.subsectionTitle}>
            {t('marketing.campaigns.details.to-buy-item')}
          </h4>
          <CampaignDetailsItemRow
            item={campaign.itemToBuy}
            quantity={campaign.nbrItemsPurchased}
            showQuantity
          />
        </div>
        <div className={Styles.section}>
          <h4 className={Styles.subsectionTitle}>
            {t('marketing.campaigns.details.to-get-item')}
          </h4>
          <CampaignDetailsItemRow
            item={campaign.itemToGet}
            quantity={campaign.nbrItemsOffer}
            showQuantity
          />
        </div>
      </div>
    </>
  )
}

export default BuyXGetYDetails
